import { TimelineExtensionRequests } from "@/types/projectType";

type BrandExtensionNoticeProps = {
  requests?: TimelineExtensionRequests[];
  stageLabel?: string;
};

const BrandExtensionNotice = ({
  requests = [],
  stageLabel = "review",
}: BrandExtensionNoticeProps) => {
  const brandRequests = [...requests]
    .filter((item) => item.requestedBy === "user")
    .sort(
      (a, b) =>
        new Date(b.requestedAt).getTime() - new Date(a.requestedAt).getTime(),
    );

  const latest = brandRequests[0];
  if (!latest) return null;

  return (
    <div className="mb-4 rounded-lg border border-[#FEF0C7] bg-[#FFFAEB] px-4 py-3">
      <p className="text-sm font-semibold text-[#B54708]">
        Brand requested more {stageLabel} time
      </p>
      <p className="mt-1 text-xs leading-5 text-[#667085]">
        The client added {latest.extensionTime} hour
        {latest.extensionTime === 1 ? "" : "s"} to their approval window.
        {latest.reason ? ` Note: ${latest.reason}.` : ""} Your deadline is
        unchanged; approval may take longer than usual.
      </p>
    </div>
  );
};

export default BrandExtensionNotice;
